function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = "/dashboard";
const ROOTS_PUBLIC = "/propuesta";

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  //   tareas: path(ROOTS_DASHBOARD, "/kanban"),
  clientes: {
    root: path(ROOTS_DASHBOARD, "/clientes"),
    listar: path(ROOTS_DASHBOARD, "/clientes/listar"),
    grupos: path(ROOTS_DASHBOARD, "/clientes/grupos"),
    planes: path(ROOTS_DASHBOARD, "/clientes/planes"),
  },
  tareas: {
    root: path(ROOTS_DASHBOARD, "/tareas"),
    listar: path(ROOTS_DASHBOARD, "/tareas/listar"),
    agregar: path(ROOTS_DASHBOARD, "/tareas/nueva-tarea"),
  },
  propuestas: {
    root: path(ROOTS_DASHBOARD, "/propuestas"),
    listar: path(ROOTS_DASHBOARD, "/propuestas/listar"),
    agregar: path(ROOTS_DASHBOARD, "/propuestas/nueva-v2"),
  },
  empleados: {
    root: path(ROOTS_DASHBOARD, "/empleados"),
    ver: path(ROOTS_DASHBOARD, "/empleados/ver"), // Nueva
    actividad: path(ROOTS_DASHBOARD, "/empleados/actividad"), // Nueva
    dashboard: path(ROOTS_DASHBOARD, "/rendimiento"),
  },
};

export const PUBLIC_PATHS = {
  verificarQR: path(ROOTS_PUBLIC, "/verificar-qr"),
  ver: path(ROOTS_PUBLIC, "/ver"),
  verV2: path(ROOTS_PUBLIC, "/v2/ver"),
};
